module.exports = __webpack_public_path__ + "img/zuanjie1.35badcef.jpg";